import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { RoleAllowBrand } from '../../../../../auth/roleAware';
import RoleAwareLink from '../../../../../common/RoleAwareLink';
import Layout from '../../../components/Layout';
import Filters from '../CustomReportFilters/CustomReportFiltersContainer';
import ShopFilter from '../CustomReportFilters/ShopFilterContainer';
import BarberFilter from '../CustomReportFilters/BarberFilterContainer';
import { REPORT_TYPES } from '../../constants';
import { getEditCustomReportLink } from '../../utils';
import ReportData from './ReportDataContainer';
import { reportDefinition as reportDefinitionProp } from '../../shapes';
import { CUSTOM_REPORTS_HELP_URL } from '../../../../../common/KnowledgeArticleLink/constants';
import KnowledgeArticleLink from '../../../../../common/KnowledgeArticleLink';

const CustomReport = ({
  reportDefinition,
  isDirty,
  reportData,
  isReportDataFetched,
}) => (
  <Layout
    title={(
      <span>
        { reportDefinition.name }
        {' '}
        <KnowledgeArticleLink url={CUSTOM_REPORTS_HELP_URL} />
      </span>
    )}
  >
    <div className="o-flexbox u-width-100">
      <Filters>
        <RoleAllowBrand display-if={reportDefinition.type === REPORT_TYPES.LOCATION}>
          <div className="c-report-filters__item">
            <ShopFilter />
          </div>
        </RoleAllowBrand>
        <div className="c-report-filters__item" display-if={reportDefinition.type === REPORT_TYPES.BARBER}>
          <BarberFilter />
        </div>
      </Filters>
      <RoleAllowBrand>
        <RoleAwareLink
          to={getEditCustomReportLink(reportDefinition)}
          className="c-btn c-btn--white c-btn--medium"
        >
          Edit Report
        </RoleAwareLink>
      </RoleAllowBrand>
    </div>
    <div className={classnames('u-mt', { 'u-dimmed': isDirty })}>
      <div display-if={isReportDataFetched && !reportData.length}>
        No data for selected date range and filters
      </div>
      <div display-if={!isReportDataFetched}>
        Run report to see data
      </div>
      <ReportData
        reportData={reportData}
        reportDefinition={reportDefinition}
        isReportDataFetched={isReportDataFetched}
      />
    </div>
  </Layout>
);

CustomReport.propTypes = {
  reportDefinition: reportDefinitionProp.isRequired,
  isDirty: PropTypes.bool.isRequired,
  reportData: PropTypes.array.isRequired,
  isReportDataFetched: PropTypes.bool.isRequired,
};

export default CustomReport;
